import React from "react";
import classnames from "classnames";
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import PageHeader from "components/PageHeader/PageHeader.js";
import Footer from "components/Footer/Footer.js";

// reactstrap components
import {
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";


export default function Tabs() {
  const [iconTabs, setIconsTabs] = React.useState(1);
  const [textTabs, setTextTabs] = React.useState(4);
  return (
    <>
    <IndexNavbar />
    <div className="section section-tabs">
      <Container>
        <div className="title">
          <h3 className="mb-3">Missão, visão e valores</h3>
        </div>
        <Row>
          <Col className="ml-auto mr-auto" md="10" xl="6">

            <Card>

              <CardBody>
                <img src="/pilares.jpeg"/>
              </CardBody>
            </Card>
          </Col>          

          <Col className="ml-auto mr-auto" md="10" xl="6">
            <Card>
              <CardHeader>
                <Nav className="nav-tabs-info" role="tablist" tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: textTabs === 4,
                      })}
                      onClick={(e) => setTextTabs(4)}
                      href="#pablo"
                    >
                      Missão
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: textTabs === 5,
                      })}
                      onClick={(e) => setTextTabs(5)}
                      href="#pablo"
                    >
                      Visão
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: textTabs === 6,
                      })}
                      onClick={(e) => setTextTabs(6)}
                      href="#pablo"
                    >
                      Valores
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent className="tab-space" activeTab={"link" + textTabs}>
                  <TabPane tabId="link4">
                    <h4>
                    • Impactar gerações com o conhecimento da glória de Deus.
                    </h4>
                    <h4>
                    • Ir por todo o mundo pregando a toda criatura.
                    </h4>         
                    <h4>
                    • Construir uma comunidade biblicamente saudável.
                    </h4>    
                    <h4>
                    • Discipular, capacitar e ensinar. 
                    </h4>                                                
                  </TabPane>
                  <TabPane tabId="link5">
                  <h4>
                    • GeraçõeS.
                    </h4>
                    <h4>
                    • Igreja Forte.
                    </h4> 
                  </TabPane>
                  <TabPane tabId="link6">
                  <h4>
                    • Sermos uma igreja biblicamente saudável.
                    </h4>
                    <h4>
                    • Cristocêntrica.
                    </h4> 
                    <h4>
                    • Conectados por elos de amor.
                    </h4>                     
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    <Footer />
    </>
  );
}
